import * as angular from "angular";
import * as _ from "lodash";
import {IController} from "angular";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DepotsAlerts} from "../../services/depots-alerts.service";

export class DepotContactPeopleViewCtrl implements IController {

  depot: any;
  private depotRef: any;
  private depotCopy: any;
  private isSaveAvailable: boolean;

  /* @ngInject */
  constructor(private $depots, private bringozLoaderService: BringozLoaderService, private $log,
              private depotsAlerts: DepotsAlerts) {

  }

  $onInit() {
    this.depotRef = this.$depots(this.depot.id);
    this.depotCopy = angular.copy(this.depot);
  }

  onAddContact() {
    if (!this.depotCopy.contactPeople) {
      this.depotCopy.contactPeople = [];
    }
    this.depotCopy.contactPeople.push({});
    this.onUpdate();
  }

  onUpdate() {
    this.isSaveAvailable = !_.isEqual(this.depot, this.depotCopy);
  }

  onRemoveContact(index) {
    this.depotCopy.contactPeople.splice(index, 1);
    this.onUpdate();
  }

  onCancelChanges(){
    this.depotCopy = angular.copy(this.depot);
    this.onUpdate();
  }

  onSave(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this._updateDepot();
      }
    }
  }

  onContactPhoneChange($index, phone) {
    this.depotCopy.contactPeople[$index].phoneNumber = phone;
    this.onUpdate();
  }

  private _updateDepot() {
    this.bringozLoaderService.on();
    this.depotRef.$update(this.depotCopy)
      .then((updatedDepot) => {
        this.isSaveAvailable = false;
        this.depot = updatedDepot;
        this.depotCopy = angular.copy(updatedDepot);
        this.depotsAlerts.updateSuccess();
      })
      .catch((error) => {
        this.depotsAlerts.updateSuccess();
        this.$log.error('Failed to update depot @Depot@onSave', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

}

angular
  .module('bringoz.admin.depots')
  .component('depotContactPeopleView', {
    bindings: {
      depot: '<'
    },
    template: require('./depot-contact-people-view.html').default,
    controller: DepotContactPeopleViewCtrl
  });
